import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../components/SectionFormContainer'
import MultilineTextField from '../../../TextEntry/MultilineTextField'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import useGroomingProfile from './hooks/useGroomingProfile'

const ClientNotes = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading } = useGroomingProfile()

	const handleTextEntry = useCallback(
		(e) => {
			const value = e.target.value
			const newValues = { ...wizard_state }
			newValues[attr] = value
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<MultilineTextField
				minRows={8}
				disabled={loading}
				label="Type answer here..."
				variant="outlined"
				value={wizard_state[attr]}
				onChange={handleTextEntry}
			/>
		</SectionFormContainer>
	)
}

export default ClientNotes
